<template>
  <div>
    <a-modal
      v-model:open="open"
      :title="$t('click.stock')"
      centered
      @ok="handleOk"
      @cancel="handleClose"
      width="800px"
    >
      <a-form
        style="margin-top: 30px"
        :model="formState"
        layout="vertical"
        autocomplete="off"
        ref="formRef"
      >
        <a-row :gutter="[16, 12]">
          <a-col :span="12">
            <a-form-item :label="$t('click.spareCode')" name="Code">
              <a-input v-model:value="formState.Code" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('click.spareName')" name="Name">
              <a-input v-model:value="formState.Name" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('click.specs')" name="Specifications">
              <a-input v-model:value="formState.Specifications" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('click.size')" name="Size">
              <a-input v-model:value="formState.Size" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('click.Threshold')"
              name="Threshold"
              :rules="[{ required: true, validator: checkPhone }]"
            >
              <a-input v-model:value="formState.Threshold" type="number" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('click.createTime')" name="CreateTime">
              <a-input v-model:value="formState.CreateTime" :disabled="true" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <template #footer>
        <!-- <a-button @click="handleCancel">{{ $t("click.notnow") }}</a-button> -->
        <a-button
          key="submit"
          type="primary"
          :loading="loadingButton"
          @click="handleOk"
          :disabled="
            formState.Threshold == undefined
              ? true
              : formState.Threshold < 0
              ? true
              : formState.Threshold == null
              ? true
              : formState.Threshold == ''
              ? true
              : false
          "
          >{{ $t("click.submit") }}</a-button
        >
      </template>
    </a-modal>
    <div class="header">
      <span class="back" @click="back">{{ $t("index.back") }}</span>
    </div>
    <div class="inner">
      <!-- <a-card :bordered="false" style="margin-bottom: 10px">
        <a-form
          ref="searchFormRef"
          name="advanced_search"
          class="ant-advanced-search-form"
          :model="searchFormState"
        >
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item name="searchKey" :label="$t('click.event')">
                <a-input
                  v-model:value="searchFormState.searchKey"
                  :placeholder="$t('click.eventin')"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="loadData()">
                {{ $t("click.search") }}
              </a-button>
              <a-button class="snowy-buttom-left" @click="reset">
                {{ $t("click.resert") }}
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </a-card> -->
      <a-card :bordered="false">
        <a-table
          ref="table"
          :columns="columns"
          :dataSource="dataSource"
          :expand-row-by-click="true"
          :alert="options.alert.show"
          bordered
          :row-key="(record) => record.UserId"
          :row-selection="options.rowSelection"
          @on-request="onRequest"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <!-- <template #operator class="table-operator"> </template> -->
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'action'">
              <a @click="editor(record)">{{ $t("click.edit") }}</a>
              <a-divider type="vertical" />
              <!-- <a @click="menuForm.onOpen(record)">绑定菜单</a>
                            <a-divider type="vertical" />
                            <a @click="roleForm.onOpen(record)">绑定角色</a>
                            <a-divider type="vertical" /> -->
              <a-popconfirm title="确定重置此备件保修次数？" @confirm="removeOrg(record)">
                <a-button type="link" size="small">重置报修</a-button>
              </a-popconfirm>
            </template>
          </template>
        </a-table>
      </a-card>
    </div>
  </div>
</template>
<script setup>
import { h, ref, computed, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { Modal } from "ant-design-vue";
import { EditOutlined } from "@ant-design/icons-vue";
import { TypographyParagraph } from "ant-design-vue";
// import Form from "./StockForm.vue";

const { t } = useI18n();
/**用户信息 */
const user = ref(JSON.parse(localStorage.getItem("user")));
/**弹窗状态 */
const open = ref(false);
/**弹窗表单数据 */
const formState = ref({
  Code: undefined,
  Name: undefined,
  Specifications: undefined,
  Size: undefined,
  Threshold: undefined,
  CreateTime: undefined,
});
/**搜索条内容 */
let searchFormState = reactive({});
let loading = ref(false);
let loadingButton = ref(false);
/**表单提交禁用 */
// const disabled = computed(() => {
//   // return !Object.values(formState.value).every(
//   //   (value) =>
//   //     value.Threshold !== "" && value.Threshold !== null && value.Threshold !== undefined
//   // );
// });
// const disabled = ref(false);
let pagination = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
});
const formRef = ref();
/**表单校验 */
function checkPhone(_, value) {
  const phoneVer = /[\d]/;
  if (!value) {
    return Promise.reject(new Error("请输入正确数字"));
  }
  if (value.match(phoneVer)) {
    return Promise.resolve();
  } else {
    return Promise.reject(new Error("请输入正确数字"));
  }
}
function handleTableChange(e) {
  pagination.value = e;
}
//表格数据
let dataSource = ref([]);
//定义tableDom
const table = ref(null);
const form = ref();
//定义form表单表头
const columns = [
  {
    title: "备件编码",
    dataIndex: "Code",
  },
  {
    title: "备件名称",
    dataIndex: "Name",
  },
  {
    title: "规格",
    dataIndex: "Specifications",
  },
  {
    title: "尺寸",
    dataIndex: "Size",
  },
  {
    title: "总报修次数",
    dataIndex: "SumNumber",
  },
  {
    title: "报修次数",
    dataIndex: "SubmitNumber",
  },
  {
    title: "库存阈值",
    dataIndex: "Threshold",
  },
  {
    title: "创建时间",
    dataIndex: "CreateTime",
  },
  {
    title: "操作",
    dataIndex: "action",
    width: "280px",
    align: "center",
  },
];
//列表选择配置
const options = {
  alert: {
    show: false,
    clear: () => {
      selectedRowKeys = ref([]);
    },
  },
  rowSelection: {
    onChange: (selectedRowKeys, selectedRows) => {
      selectedRowKeys.value = selectedRowKeys;
    },
  },
};

onMounted(() => {
  //获取列表数据
  filterData();
});

//获取备件列表数据
const filterData = () => {
  let params = {
    UserId: user.value.UserId,
  };
  loading.value = true;
  axios
    .post("api/ComponentUserNumber/GetList", params)
    .then((response) => {
      console.log("获取备件列表：", response.data);
      loading.value = false;
      if (response.data.code == 200 && response.data.ReturnType == true) {
        dataSource.value = response.data.ReturnData;
        pagination.value.total = response.data.TotalCount;
      } else {
        message.error("获取备件列表失败");
      }
    })
    .catch((error) => {
      loading.value = false;
      message.error("获取备件列表失败");
    });
};
// //点击搜索
// const loadData = () => {
//   let params = {
//     Name: searchFormState.searchKey,
//   };
//   //获取备件列表数据
//   filterData(params);
// };
// /**重置搜索,searchFormRef是搜索框DOM */
// const reset = () => {
//   let params = {};
//   //获取备件列表数据
//   filterData(params);
// };
//点击编辑
const editor = (record) => {
  console.log("编辑：", record);
  formState.value = record;
  open.value = true;
};
//重置报修次数
const removeOrg = (record) => {
  let params = {
    UserId: user.value.UserId,
    ComponentId: record.Id,
  };
  axios
    .post("api/ComponentUserNumber/ResetNumber", params)
    .then((response) => {
      console.log("重置报修次数：", response.data);
      if (response.data.code == 200 && response.data.ReturnType == true) {
        message.success("重置成功");
        //获取备件列表数据
        filterData();
      } else {
        message.error("重置失败");
      }
    })
    .catch((error) => {
      message.error("重置失败");
    });
};
/**返回上一页 */
function back() {
  history.back();
}

/*****************弹窗******************/
//提交备件库存
const handleOk = () => {
  console.log("提交备件库存：", formState.value);
  loadingButton.value = true;
  let params = {
    Id: formState.value.Id,
    UserId: user.value.UserId,
    Threshold: formState.value.Threshold,
  };
  console.log("提交备件库存参数：", params);
  axios
    .post("api/ComponentUserNumber/Save", params)
    .then((response) => {
      console.log("提交备件库存：", response.data);
      loadingButton.value = false;
      if (response.data.code == 200 && response.data.ReturnType == true) {
        message.success("提交成功");
        formState.value = {};
        open.value = false;
        //获取备件列表数据
        filterData();
      } else {
        message.error("提交失败");
      }
    })
    .catch((error) => {
      loadingButton.value = false;
      message.error("提交失败");
    });
};
/**关闭弹窗回调函数 */
function handleClose() {
  formState.value = {};
  open.value = false;
}
const onRequest = () => {};
</script>
<style scoped>
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}

.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}

.inner {
  margin-top: 50px;
}

a {
  color: #1890ff;
}

.workerHead {
  display: flex;
  align-items: center;
}

:deep(.workerInfo) {
  background-color: rgb(135, 208, 104);
  margin-left: 10px;
  font-weight: normal;
  font-style: italic;
}

.cardImp {
  margin-right: 10px;
}

.ant-form-item {
  margin-bottom: 0 !important;
}

.primaryAdd {
  margin-right: 10px;
}

.snowy-buttom-left {
  margin-left: 8px;
}
</style>
